import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DndDraggableDirective, DndDragImageRefDirective } from './dnd-draggable.directive';
import { DndDropzoneDirective, DndPlaceholderRefDirective } from './dnd-dropzone.directive';
import { DndHandleDirective } from './dnd-handle.directive';
export class DndModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    DndDraggableDirective,
    DndDropzoneDirective,
    DndHandleDirective,
    DndPlaceholderRefDirective,
    DndDragImageRefDirective
  ],
  exports: [
    DndDraggableDirective,
    DndDropzoneDirective,
    DndHandleDirective,
    DndPlaceholderRefDirective,
    DndDragImageRefDirective
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DndModule_tsickle_Closure_declarations() {
/** @type {?} */
DndModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DndModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
